module.exports = __webpack_public_path__ + "img/arrows-expand.44391889.svg";